// Certifications Section Data
// Edit this file to add or update certifications
// To add a new certification, add a new object to the certifications array

export const certificationsData = {
  heading: "Certifications",
  description: "Professional certifications demonstrating expertise in cloud platforms and DevOps practices",
  certifications: [
    {
      id: 1,
      name: "AWS Certified Solutions Architect – Associate",
      issuer: "Amazon Web Services",
      date: "2025",
      credentialId: "adbbdb96b1504b43ac6451013fbf02ac",
      image: "/logos/awscert.png",
      url: "https://www.credly.com/badges/07aa3267-f482-4f82-861b-c12cb5741ace"
    }
  ]
};

